import { CartPricing, PositionDiscountPreview } from '../types';

/**
 * Calculates the discounted price for a subscription based on position discount.
 */
export function calculatePositionDiscountedPrice(basePriceInCents: number, discountPercent: number): number {
  return Math.round(basePriceInCents * (1 - discountPercent / 100));
}

/**
 * Calculates the savings amount for a subscription based on position discount.
 */
export function calculatePositionSavings(basePriceInCents: number, discountPercent: number): number {
  return Math.round(basePriceInCents * (discountPercent / 100));
}

/**
 * Gets the position discount for a specific cart item, if enrolled in the experiment.
 */
export function getPositionDiscountForCartItem(
  cartPricing: CartPricing,
  cartItemId: string,
): PositionDiscountPreview | null {
  const discount = cartPricing.positionDiscounts?.[cartItemId];
  if (!discount || !discount.isEnrolled || discount.discountPercent === 0) {
    return null;
  }
  return discount;
}

/**
 * Checks if the backend cart pricing enrolls the cart in the position discount.
 */
export function isEnrolledInPositionDiscount(cartPricing?: CartPricing): boolean {
  return Object.values(cartPricing?.positionDiscounts ?? {}).some((d) => d.isEnrolled);
}
